@if (schedule) {
  <article class="theme4d23">
    <header>
      @if (!schedule.id) {
        <app-scheduler-help [step]="step"></app-scheduler-help>
      }
      @if (schedule.id) {
        <h3 title="The schedule title">{{ schedule.title }}</h3>
      }
      <div class="tabview-list">
        <div [class.active]="step === 'sites'" (click)="tabClick('sites')">
          <i class="mdi mdi-office-building-outline"></i>
          Sites
        </div>
        <div [class.active]="step === 'assets'" (click)="tabClick('assets')">
          <i class="mdi mdi-radiobox-blank"></i>
          Assets
        </div>
        <div [class.active]="step === 'date'" (click)="tabClick('date')">
          <i class="mdi mdi-calendar-clock"></i>
          Calendar
        </div>
        <!-- <div [class.active]="section==='overview'" routerLink="/setpoints/overview"><i class="fa fa-barcode"></i> Overview
      </div> -->
        <div>&nbsp;</div>
      </div>
    </header>
    <!--           S I T E S           -->
    @if (step === 'sites') {
      <section class="sites">
        <main>
          <table>
            <thead>
              <tr>
                <th (click)="selectAllClick('sites')"><app-tick [selected]="selectAllSites"></app-tick> Site</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              @for (site of sites; track site) {
                <tr>
                  <td (click)="site.checked = !site.checked">
                    <span>
                      <app-tick [selected]="site.checked"></app-tick>
                      {{ site.title }}
                    </span>
                  </td>
                  <td>{{ site.address.address1 }}</td>
                </tr>
              }
            </tbody>
          </table>
        </main>
        <footer>
          <div>
            <app-button routerLink=".." icon="mdi mdi-close" label="Cancel" />
          </div>
          <app-button (click)="next()" icon="mdi mdi-page-next-outline" label="Select assets" />
        </footer>
        <section class="mt-1">
          <p-panel header="Tip">
            <p>If you don't select any sites and you don't select any assets, this schedule will apply to every site and every matching asset type at the time the schedule runs</p>
          </p-panel>
        </section>
      </section>
    }
    <!--           A S S E T S           -->
    @if (step === 'assets') {
      <section class="assets">
        @if (assets) {
          <main>
            <div>
              <h4>Asset Title <small>optional</small></h4>
              <div>
                <p-select [options]="operations" [(ngModel)]="schedule.filter.asset.op" optionLabel="name" optionValue="code" (onChange)="locationUpdated($event)"></p-select>
                <input pInputText [(ngModel)]="schedule.filter.asset.value" placeholder="Filter by asset title containing text" (keyup)="locationUpdated($event)" />
              </div>
            </div>
            <div>
              <h4>Location <small>optional</small></h4>
              <div>
                <p-select [options]="operations" [(ngModel)]="schedule.filter.location.op" optionLabel="name" optionValue="code" (onChange)="locationUpdated($event)"></p-select>
                <input pInputText [(ngModel)]="schedule.filter.location.value" placeholder="Filter by location containing" (keyup)="locationUpdated($event)" />
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th (click)="selectAllClick('assets')"><app-tick [selected]="selectAllAssets"></app-tick> Asset</th>
                  <th>Sensor</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                @for (asset of assets; track asset) {
                  <tr (click)="asset.checked = !asset.checked">
                    <td>
                      <span>
                        <app-tick [selected]="asset.checked"></app-tick>
                        {{ asset.title }}
                      </span>
                    </td>
                    <td>{{ asset.assetTypeTitle }}</td>
                    <td>{{ asset.location }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </main>
        }
        @if (!assets) {
          <app-please-wait></app-please-wait>
        }
        <footer>
          <div>
            <app-button routerLink=".." icon="mdi mdi-close" label="Cancel"></app-button>
          </div>
          <app-button (click)="previous()" icon="mdi mdi-page-previous-outline" label="Back to Sites"></app-button>
          <app-button (click)="next()" icon="mdi mdi-page-next-outline" label="Next"></app-button>
        </footer>
        <section class="mt-1 site-tip">
          @if (this.selectAllSites) {
            <p-panel header=" Tip">
              <p>
                <u>You didn't select any sites</u>, if you don't select any assets, this schedule will apply to every site and every
                @for (assetType of selectedAssetTypes; track assetType) {
                  <span>{{ assetType.title }}</span>
                }
                sensor, at the time the schedule runs.
              </p>
            </p-panel>
          }
        </section>
      </section>
    }
    <!-- OVERVIEW -->
    @if (step === 'date') {
      <section class="date">
        <main>
          <div>
            <app-calendar [value]="schedule.processAt" (onSelect)="schedule.processAt = $event?.date"></app-calendar>
          </div>
          <div>
            <h4>Title</h4>
            <input class="form-control" [(ngModel)]="schedule.title" placeholder="Title for lists,etc." />
            <h4>Repeat</h4>
            <p-select [options]="repeatOptions" [(ngModel)]="schedule.repeats.frequency" optionLabel="name" optionValue="code"></p-select>
            <h4>Reason</h4>
            <textarea class="form-control" [(ngModel)]="schedule.reason" rows="10" placeholder="optional"></textarea>
          </div>
        </main>
        <footer>
          <div></div>
          @if (schedule.id) {
            <app-button (click)="delete()" icon="mdi mdi-trash-can-outline" label="Delete"></app-button>
          }
          <app-button routerLink="/setpoints/templates" icon="mdi mdi-close" label="Cancel" />
          <!--<app-button  (click)="previous()"
      icon="mdi mdi-page-previous-outline" label="Back to Assets"></app-button>-->
          <app-button (click)="next()" icon="mdi mdi-page-next-outline" label="Submit" />
        </footer>
        <section class="mt-1 site-tip">
          @if (this.selectAllSites && this.selectAllAssets) {
            <p-panel header=" Tip">
              <p>
                <u>You didn't select any sites OR assets</u>, this schedule will apply to every site and every
                @for (assetType of selectedAssetTypes; track assetType) {
                  <span>{{ assetType.title }}</span>
                }
                sensor, at the time the schedule runs.
              </p>
            </p-panel>
          }
        </section>
      </section>
    }
  </article>
}
